import * as React from 'react';
import * as styles from './styles.css';

export interface ITabListProps {
  children: React.ReactNode;
}

export function TabList({ children }: ITabListProps) {
  return (
    <div className={styles['container']}>
      <div className={styles['list']}>{children}</div>
    </div>
  );
}
